export enum AccionEnum { AGREGAR, ACTUALIZAR, BORRAR, OBTENER }
